import { jsx as _jsx } from "react/jsx-runtime";
import MessagingCopy from '../messaging/MessagingCopy';
import { SignupDataInputForm } from '../signup-data/SignupDataInputForm';
import { BaseView } from './BaseView';
import { getStepConfig } from './getStepConfig';
import { useView } from './useView';
import { Step } from './Step';
import { Data } from '../signup-data/DATA';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { getGuessedDataBiden } from '../store/guessed-prefill/selectors';
import { useSelector } from 'react-redux';
import { StepTitle } from '../views-components/StepTitle';
import { isInACQ140VariantACRM, isInACQ140VariantsCRM } from '../experiments/gswhV1/gswhUtils';
export const CompanyNameView = () => {
  const stepKey = Step.CompanyName;
  const dataKey = Data.CompanyName;
  const {
    submit
  } = useView({
    stepKey
  });
  const {
    isAssignedToVariant: isAssignedToVariantACQ0140,
    parameter: parameterACQ140
  } = useExperiment(ExperimentKeys.ACQ0140, TrackWhen.never);
  const guessedData = useSelector(getGuessedDataBiden(dataKey));
  const stepConfig = getStepConfig(stepKey);
  const isACQ140VariantACRM = useSelector(isInACQ140VariantACRM);
  const isACQ140VariantAorBCRM = useSelector(isInACQ140VariantsCRM);

  if (!stepConfig) {
    return null;
  }

  let helperText;

  if (isAssignedToVariantACQ0140()) {
    helperText = guessedData ? /*#__PURE__*/_jsx(MessagingCopy, {
      message: `views.${stepKey}.help`
    }) : /*#__PURE__*/_jsx(MessagingCopy, {
      message: `views.${stepKey}.subtitle`
    });
  }

  const title = isAssignedToVariantACQ0140() ? /*#__PURE__*/_jsx(StepTitle, {
    isACQ140CRM: isACQ140VariantACRM,
    message: `views.${stepKey}.title.acq140${isACQ140VariantACRM ? '_crm' : ''}`,
    stepKey: Step.CompanyName
  }) : null;
  const preTitleMessage = isACQ140VariantAorBCRM ? `views.${stepKey}.pre-title.acq140.${parameterACQ140}_crm` : undefined;
  return /*#__PURE__*/_jsx(BaseView, {
    helperText: helperText,
    preTitleMessage: preTitleMessage,
    title: title,
    children: /*#__PURE__*/_jsx(SignupDataInputForm, {
      dataKey: dataKey,
      inputMode: 'text',
      submit: submit
    }, dataKey)
  });
};